import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
// import { DataGrid } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';

import Header from '../components/Header';
import Footer from '../components/Footer';

// import SignOutButton from '../components/SignOutButton';
import { fetchToken } from '../components/Auth';
import { useGetApi } from '../components/ApiAccess';
import { getSelfClient } from '../components/ApiAccess';
import { fetchSelfUserInfo } from '../components/Auth';

/**
 * 企業情報表示・編集画面
 * @returns
 */
export default function Profile() {
  const navigate = useNavigate();

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { isDirty, errors },
  } = useForm();

  const [errorResult, setErrorResult] = useState('');

  const [data, setData] = useState({ account: {}, notification: {} });
  const params = useParams();

  const [mode, setMode] = useState();

  const getClient = useGetApi('/api/v1/clients/' + params.clientId + '/');
  const getApiKey = useGetApi('/api/v1/apiKey/?id=' + params.clientId);
  const [clientId, setClientId] = useState();
  const [isApiKeyActive, setIsApiKeyActive] = useState(false);

  const userInfo = fetchSelfUserInfo();

  useEffect(() => {
    if (params.clientId) {
      getClient().then((response) => {
        const data = Object.assign({}, response.data);
        setViewData(data);

        const d = new Date(response.data.created_at);

        getApiKey().then((response) => {
          setIsApiKeyActive(response.data.is_active);
        });
      });

      setClientId(params.clientId);
    } else {
      getSelfClient().then((response) => {
        const data = Object.assign({}, response.data);
        setViewData(data);

        setClientId(response.data.id);
      });
    }
  }, []);

  const setViewData = (data) => {
    data.account = data.account || {};
    data.account.updated_at = data.account.updated_at || '';

    data.clientId = data.id;
    data.clientName = data.name;
    data.createdAt = new Date(data.created_at).toLocaleDateString();
    data.updatedAt =
      data.updated_at > data.account.updated_at
        ? new Date(data.updated_at).toLocaleDateString()
        : new Date(data.account.updated_at).toLocaleDateString();

    data.notification = data.notifications[0] || {};

    setData(data);
  };

  const onUpdate = (formData, event) => {
    if (!isDirty) {
      setMode('');
      return;
    }

    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const putData = {
      name: formData.clientName || data.clientName,
      account: {
        email: formData.email || data.account.email,
        password: formData.password,
      },
      notifications: [
        {
          email: formData.notification || data.notification.email,
          is_active: formData.notification_is_active, //|| data.notification.is_active
        },
      ],
    };

    if (putData.notifications[0].is_active !== true && !putData.notifications[0].email) {
      // putData.notifications = [];
      delete putData['notifications'];
    }

    axios
      .put('/api/v1/clients/' + clientId + '/', putData, { headers: headers })
      .then((response) => {
        const data = Object.assign({}, response.data);
        setViewData(data);
        setErrorResult();
        setMode('');
        reset();
      })
      .catch((error) => {
        const res = error.response || error;
        const data = res.data || error;
        const detail = data.detail || 'エラーが発生しました';
        setErrorResult(detail);
      })
      .finally(() => {
        if (putData.account) {
          putData.account.password = undefined;
        }
        if (formData.password) {
          formData.password = undefined;
        }
      });
  };

  const handleShowApiKey = (event, id) => {
    navigate('/clients/' + id + '/key');
  };

  return (
    <div className='profile'>
      <Header></Header>
      <main>
        <Container>
          <h2>クライアント情報</h2>
          {errorResult && (
            <Alert key={'danger'} variant={'danger'}>
              Error: {errorResult}
            </Alert>
          )}
          <div className={'form-wrapper'}>
            <Form noValidate onSubmit={handleSubmit(onUpdate)}>
              <Form.Group className="mb-3" controlId="clientId">
                <Form.Label className="h5">ID</Form.Label>
                <Form.Control plaintext readOnly defaultValue={data.id} />
              </Form.Group>

              <Form.Group className="mb-3" controlId="clientName">
                <Form.Label className="h5">
                  企業名
                  {mode === 'edit' && userInfo.is_superuser ? (
                    <>
                      {' '}
                      <Badge bg="danger">必須</Badge>
                    </>
                  ) : (
                    <></>
                  )}
                </Form.Label>
                {mode === 'edit' && userInfo.is_superuser ? (
                  <>
                    <Form.Control
                      type="text"
                      placeholder="例：株式会社〇〇〇〇"
                      defaultValue={data.name}
                      isInvalid={!!errors.clientName}
                      {...register('clientName', { required: true })}
                    />
                    {errors.clientName && (
                      <Form.Control.Feedback type="invalid">
                        入力が必須の項目です
                      </Form.Control.Feedback>
                    )}
                  </>
                ) : (
                  <Form.Control plaintext readOnly defaultValue={data.name} />
                )}
              </Form.Group>

              {mode === 'password' ? (
                <></>
              ) : (
                <>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label className="h5">ログインID（メールアドレス）</Form.Label>
                    {mode === 'edit' && userInfo.is_superuser ? (
                      <>
                        <Form.Control
                          type="email"
                          placeholder="例：example@example.jp"
                          defaultValue={data.account.email}
                          isInvalid={!!errors.email}
                          {...register('email', { required: true })}
                        />
                        {errors.email && (
                          <Form.Control.Feedback type="invalid">
                            入力が必須の項目です
                          </Form.Control.Feedback>
                        )}
                      </>
                    ) : (
                      <Form.Control plaintext readOnly defaultValue={data.account.email} />
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="notification">
                    <Form.Label className="h5">
                      通知メール設定
                      {mode === 'edit' ? (
                        <></>
                      ) : (
                        <>（通知設定：{data.notification.is_active ? 'ON' : 'OFF'}）</>
                      )}
                    </Form.Label>
                    {mode === 'edit' ? (
                      <>
                        <Form.Control
                          type="email"
                          placeholder="例：example@example.jp"
                          defaultValue={data.notification.email}
                          isInvalid={!!errors.notification}
                          {...register('notification', {})}
                        />
                        {errors.notification && (
                          <Form.Control.Feedback type="invalid">
                            入力が必須の項目です
                          </Form.Control.Feedback>
                        )}
                      </>
                    ) : (
                      <>
                        {!data.notification.email ? (
                          <>
                            <div className={'form-control-plaintext'}>未設定</div>
                          </>
                        ) : (
                          <>
                            <Form.Control
                              plaintext
                              readOnly
                              defaultValue={data.notification.email}
                            />
                          </>
                        )}
                        <p className="small text-muted">
                          ※ 施策への流入があったときにこちらのメールアドレスに対して通知を行います。
                          <br />
                          　未入力、通知設定OFF の場合は送信されません。
                          <br />
                        </p>
                      </>
                    )}
                  </Form.Group>
                  {mode === 'edit' ? (
                    <>
                      <Form.Group as={Row} className="mb-3" controlId="notification_is_active">
                        <Form.Label as={Col} sm={10}>
                          通知許可
                        </Form.Label>
                        <Col sm={2}>
                          <Form.Check type={'checkbox'} className={'toggle-switch'}>
                            <Form.Check.Input
                              className="toggle-switch-checkbox"
                              defaultChecked={data.notification.is_active}
                              {...register('notification_is_active')}
                            ></Form.Check.Input>
                            <Form.Check.Label className="toggle-switch-label">
                              <span className="toggle-switch-inner" />
                              <span className="toggle-switch-switch" />
                            </Form.Check.Label>
                          </Form.Check>
                        </Col>
                      </Form.Group>
                      <p className="small text-muted">
                        ※ 施策への流入があったときにこちらのメールアドレスに対して通知を行います。
                        <br />
                        　未入力、通知設定OFF の場合は送信されません。
                        <br />
                      </p>
                    </>
                  ) : (
                    <></>
                  )}
                  <div></div>
                </>
              )}

              {mode ? (
                <></>
              ) : (
                <>
                  {/* API */}
                  {userInfo.is_superuser && (
                    <Form.Group className="mb-3" controlId="isApiKeyActive">
                      <Form.Label className="h5">APIキー</Form.Label>
                      <div className="d-flex ">
                        <Form.Control
                          plaintext
                          readOnly
                          value={isApiKeyActive ? '利用中' : '利用不可'}
                        />
                        <Button
                          variant="outline-dark"
                          size="sm"
　　　　　　　　　　　　　　　 className="api-key-detail-btn"
                          onClick={(event) => handleShowApiKey(event, data.id)}
                        >
                          詳細を確認する
                        </Button>
                      </div>
                    </Form.Group>
                  )}

                  <Form.Group className="mb-3" controlId="createdAt">
                    <Form.Label className="h5">登録日</Form.Label>
                    <Form.Control plaintext readOnly defaultValue={data.createdAt} />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="updatedAt">
                    <Form.Label className="h5">更新日</Form.Label>
                    <Form.Control plaintext readOnly defaultValue={data.updatedAt} />
                  </Form.Group>
                </>
              )}

              {mode === 'password' ? (
                <>
                  <Form.Group className="mb-3" controlId="password">
                    <Form.Label className="h5">パスワード</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="半角英数字"
                      isInvalid={!!errors.password}
                      {...register('password', { required: true })}
                    />
                    {errors.password && (
                      <Form.Control.Feedback type="invalid">
                        入力が必須の項目です
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="confirmPassword">
                    <Form.Label className="h5">パスワード確認用</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="半角英数字"
                      isInvalid={!!errors.confirmPassword}
                      {...register('confirmPassword', {
                        required: '入力が必須の項目です',
                        validate: (value) => {
                          if (watch('password') !== value) {
                            return 'パスワードが一致しません';
                          }
                        },
                      })}
                    />
                    {errors.confirmPassword && (
                      <>
                        <Form.Control.Feedback type="invalid">
                          <ErrorMessage
                            errors={errors}
                            name="confirmPassword"
                            render={({ message }) => <p>{message}</p>}
                          />
                        </Form.Control.Feedback>
                      </>
                    )}
                  </Form.Group>
                </>
              ) : (
                <></>
              )}

              <div className="d-flex justify-content-center">
                <ButtonToolbar className="mx-auot">
                  {mode ? (
                    <>
                      <ButtonGroup className="">
                        <Button type="submit" variant="dark">
                          完了する
                        </Button>
                      </ButtonGroup>
                    </>
                  ) : (
                    <>
                      <ButtonGroup className="me-2">
                        <Form.Label
                          className="btn btn-dark profile-edit-label"
                          onClick={(event) => {
                            setMode('edit')
                            reset();
                          }}
                        >
                          編集する
                        </Form.Label>
                      </ButtonGroup>
                          
                      <ButtonGroup className="">
                        <Form.Label
                          className="btn btn-dark btn-password-label"
                          onClick={(event) => setMode('password')}
                        >
                          パスワード編集
                        </Form.Label>
                      </ButtonGroup>
                    </>
                  )}
                </ButtonToolbar>
              </div>
            </Form>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
